import React, { useEffect, useRef, useState } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Link from '../Link/Link'
import LNULogoImgSv from '../images/logo-wordmark-sv.png'
import LNULogoImgEn from '../images/logo-wordmark-en.png'
import logoImg from '../images/tree.svg'
import {NavBarStyle, HeaderWrapperStyle, CourseNameStyle, TreeLogoStyle, LnuTextStyle, UnStickyTriggerStyle, ToolsLinkStyle, HamburgerMenuButtonStyle } from './Header.css'
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver'
import config from '../../../config'

const Header = ({ location }) => (
  <StaticQuery
    query={graphql`
      query headerTitleQuery {
        site {
          siteMetadata {
            headerTitle
            courseName
            logo {
              link
            }
            headerLinks {
              link
              text
            }
          }
        }
      }
    `}
    render={data => {
      const {
        site: {
          siteMetadata: { headerTitle, courseName, logo, headerLinks }
        }
      } = data

       const headerRef = useRef(null);

      const unStickyShowing = useIntersectionObserver(headerRef)
      useEffect(() => {
        document.body.classList.toggle("stickyMode", !unStickyShowing);
      },[unStickyShowing])


      const finalLogoLink = logo.link !== '' ? logo.link : '/'
      return (
          <>
          <span css={UnStickyTriggerStyle} ref={headerRef}></span>
          <nav css={NavBarStyle}> 
            <div css={HeaderWrapperStyle} >
              <Link to={finalLogoLink}>
                <span css={TreeLogoStyle}>
                  <img src={logoImg} alt={'logo'} />
                </span>
                <div css={LnuTextStyle}>
                  <img src={config.siteMetadata.language === "sv" ? LNULogoImgSv : LNULogoImgEn} alt={headerTitle} />
                  <div css={CourseNameStyle}>{courseName}</div>
                </div>
              </Link>
            </div>
            <ul css={ToolsLinkStyle}>
              {headerLinks.map((link, key) => {
                if (link.link !== '' && link.text !== '') {
                  return (
                    <li key={key}>
                      <a href={link.link} target='_blank'>{link.text}</a>
                    </li>
                  )
                }
              })}
            </ul>
            <button className="toggleLeftMenu" css={HamburgerMenuButtonStyle} onClick={() => document.body.classList.toggle("menuOpen")}></button>
          
          </nav></>
      )
    }}
  />
)

export default Header
